export { default as Field } from './Field';



// WEBPACK FOOTER //
// ./src/mundial/Vcards/VcardMatch/Alignment/Field/index.ts